import { StyledSider } from "./styled";
import { MenuList } from "../MenuList/MenuList";

export const Sider = () => {
  return (
    <StyledSider style={{ position: 'fixed' ,overflow: 'auto',}} width="240px">
      <MenuList />
    </StyledSider>
  );
};
